<app-card [title]="'Confirm your information'">
	<form [formGroup]="patientInfoForm">
		<div class="profile-container">
			<h2>Patient Details</h2>
			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>First Name</mat-label>
					<input matInput formControlName="firstName" placeholder="First Name" readonly required>
					<mat-error *ngIf="patientInfoForm.get('firstName')?.invalid">First name is required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Last Name</mat-label>
					<input matInput formControlName="lastName" placeholder="Last Name" readonly required>
					<mat-error *ngIf="patientInfoForm.get('lastName')?.invalid">Last name is required</mat-error>
				</mat-form-field>
			</div>
			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Date Of Birth</mat-label>
					<input matInput [matDatepicker]="picker" formControlName="birthdate" placeholder="Date Of Birth"
						readonly required>
					<mat-datepicker-toggle matSuffix [for]="picker" [disabled]="true"></mat-datepicker-toggle>
					<mat-datepicker #picker [disabled]="true"></mat-datepicker>
					<mat-error *ngIf="patientInfoForm.get('birthdate')?.invalid">Date Of Birth is required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Email Address</mat-label>
					<input matInput formControlName="email" placeholder="Email Address" readonly required>
					<mat-error *ngIf="patientInfoForm.get('email')?.invalid">Please enter a valid Email Address</mat-error>
				</mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Primary Phone Number</mat-label>
					<input matInput formControlName="phone" placeholder="Primary Phone Number" readonly required>
					<mat-error *ngIf="patientInfoForm.get('phone')?.hasError('pattern')">
						Please enter a valid 10-digit Phone Number. 
					</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Alternate Phone Number</mat-label>
					<input matInput formControlName="altPhone" placeholder="Alternate Phone Number" readonly>
					<mat-error *ngIf="patientInfoForm.get('altPhone')?.hasError('pattern')">
						Please enter a valid 10-digit Phone Number. 
					</mat-error>
				</mat-form-field>

			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>US Resident</mat-label>
					<mat-select formControlName="usCitizen" required>
						<mat-option value="yes">Yes</mat-option>
						<mat-option value="no">No</mat-option>
					</mat-select>
					<mat-error *ngIf="patientInfoForm.get('usCitizen')?.invalid">Resident check is required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Assigned Gender at Birth</mat-label>
					<mat-select formControlName="gender" required>
						<mat-option value="M">Male</mat-option>
						<mat-option value="F">Female</mat-option>
					</mat-select>
					<mat-error *ngIf="patientInfoForm.get('gender')?.invalid">Gender is required</mat-error>
				</mat-form-field>
			</div>

			<h2>Home Address</h2>
			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Address Line 1</mat-label>
					<input matInput formControlName="billingAddress1" placeholder="Address Line 1" required readonly>
					<mat-error *ngIf="patientInfoForm.get('billingAddress1')?.invalid">Address line 1 is
						required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Address Line 2</mat-label>
					<input matInput formControlName="billingAddress2" placeholder="Address Line 2" readonly>
				</mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>City</mat-label>
					<input matInput formControlName="billingCity" placeholder="City" required readonly>
					<mat-error *ngIf="patientInfoForm.get('billingCity')?.invalid">City is required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>State</mat-label>
					<mat-select formControlName="billingState" required readonly>
						<mat-option *ngFor="let state of states" [value]="state.stateProvCode" >
							{{ state.stateProvName }}
						</mat-option>
					</mat-select>

					<mat-error *ngIf="patientInfoForm.get('billingState')?.invalid">State is required</mat-error>
				</mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-zipfield">
					<mat-label>Zip Code</mat-label>
					<input matInput formControlName="billingZip" placeholder="Zip Code" required readonly>
					<mat-error *ngIf="patientSubgroup.get('billingZip')?.invalid">
						Please enter a valid ZIP Code.
					</mat-error>
				</mat-form-field>
			</div>

			<div class="shipping-header">
				<h2>Shipping Address</h2>
				<mat-slide-toggle [formControl]="sameAddressControl" (change)="onToggleChange($event.checked)" readonly>
					Same as Home Address
				</mat-slide-toggle>
			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Address Line 1</mat-label>
					<input matInput formControlName="shippingAddress1" placeholder="Address Line 1" required readonly>
					<mat-error *ngIf="patientInfoForm.get('shippingAddress1')?.invalid">Shipping address line 1 is
						required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>Address Line 2</mat-label>
					<input matInput formControlName="shippingAddress2" placeholder="Address Line 2" readonly>
				</mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-field">
					<mat-label>City</mat-label>
					<input matInput formControlName="shippingCity" placeholder="Shipping City" required readonly>
					<mat-error *ngIf="patientInfoForm.get('shippingCity')?.invalid">Shipping city is
						required</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field">
					<mat-label>State</mat-label>
					<mat-select formControlName="shippingState" required readonly>
						<mat-option *ngFor="let state of states" [value]="state.stateProvCode" >
							{{ state.stateProvName }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="patientInfoForm.get('shippingState')?.invalid">Shipping state is
						required</mat-error>
				</mat-form-field>
			</div>

			<div class="form-row">
				<mat-form-field appearance="outline" class="form-zipfield">
					<mat-label>Zip Code</mat-label>
					<input matInput formControlName="shippingZip" placeholder="Shipping Zip Code" required readonly>
					<mat-error *ngIf="patientSubgroup.get('shippingZip')?.invalid">
						Please enter a valid ZIP Code.
					</mat-error>
				</mat-form-field>
			</div>
			<div class="profile-button-container">
				<p class="info-text">This information cannot be changed once you submit.</p>
				<div class="button-row">
					<button class="button-Secondary" (click)="onSave(true)" [disabled]="!patientSubgroup.valid" type="submit">Save And Exit</button>
					<button class="button-Primary" (click)="onSave()" [disabled]="!patientSubgroup.valid">Next :
						{{nextStep?.enrollmentStepName}}</button>
				</div>
			</div>
		</div>
	</form>
</app-card>

<loading-spinner *ngIf="isLoading"></loading-spinner>